export function mapServerDataToGridData(data) {
  return data.map(task => {
    return {
      id: task.id,
      description: task.description ?? "",
      supplier: task.supplier?.name ?? "",
      assigneeName: task.assigneeName ?? ""
    };
  });
}